import React from 'react'
import { Link } from 'react-router-dom'
interface CurrentStageButtonProps {
  currentStage: string;
}
export default function CurrentStageButton ({ currentStage }: CurrentStageButtonProps) {
  return (
    <li>
        {
            currentStage === "medical" && <Link to='/medical-print-slip' className='nav-link dropdown-toggle' role='button' data-toggle='dropdown'>Print Medical Slip</Link>
         }
         { currentStage === "aptitude" && <Link to='/print-aptitude-slip' className='nav-link dropdown-toggle' role='button' data-toggle='dropdown'>Print Aptitude Slip</Link>
        }
                 {/* { currentStage === "aptitude" && <Link to='/faq' className='nav-link dropdown-toggle' role='button' data-toggle='dropdown'>FAQ</Link> */}
                 { currentStage === "institution" && <Link to='/download-shortlisted' className='nav-link dropdown-toggle' role='button' data-toggle='dropdown'>Download Shortlisted</Link>
        }
                 { currentStage === "pscreen" && <Link to='/print-screen-status' className='nav-link dropdown-toggle' role='button' data-toggle='dropdown'>Print Screen Schedule</Link>
        }
    </li>
  )
}
